import { render, staticRenderFns } from "./VeHrPeixunList.vue?vue&type=template&id=ef8202b0&scoped=true"
import script from "./VeHrPeixunList.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8202b0",
  null
  
)

export default component.exports